export default Object.freeze({
  DEVELOPMENT: 'development',
  PRODUCTION: 'production',
});
